// extracted by mini-css-extract-plugin
export default {"image-attachment__inner":"image-attachment__inner__yGCaU"};